import { ReadonlyURLSearchParams } from 'next/navigation'

export const CREATE_ACCOUNT_TYPES = [
  'operating',
  'automation',
  'card',
  'imported',
] as const
export type CreateAccountType = (typeof CREATE_ACCOUNT_TYPES)[number]

// The type selection page. Cancel on a create page falls back here when the
// entry point did not pass a returnTo (see useReturnPath).
export const CREATE_ACCOUNT_PATH = '/accounts/create'

// The import page with no import in progress: the form, rather than the
// progress view an importAccountId would resume.
export const IMPORT_ACCOUNT_PATH = `${CREATE_ACCOUNT_PATH}/imported`

// Entry points that skip the type selection pass the page they came from, so
// Cancel returns there.
export const buildCreatePath = ({
  type,
  returnTo,
}: {
  type: CreateAccountType
  returnTo: string
}) => `${CREATE_ACCOUNT_PATH}/${type}?${new URLSearchParams({ returnTo })}`

// The pre-selection create page kept the account type in ?type. Redirect
// those URLs to the dedicated pages and keep the remaining params, which the
// import flow resumes from. For example, /accounts/create?type=imported&importAccountId=abc
// becomes /accounts/create/imported?importAccountId=abc.
export const getLegacyCreateRedirect = (
  searchParams: ReadonlyURLSearchParams,
): string | null => {
  const typeParam = searchParams.get('type') as CreateAccountType | null
  if (!typeParam || !CREATE_ACCOUNT_TYPES.includes(typeParam)) return null

  const nextSearchParams = new URLSearchParams(searchParams)
  nextSearchParams.delete('type')
  const query = nextSearchParams.toString()
  return `${CREATE_ACCOUNT_PATH}/${typeParam}${query ? `?${query}` : ''}`
}
